// #region Imports
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { FormattedMessage, defineMessages } from 'react-intl';
import { ButtonStyled } from 'shared/DesignSpecs/components/FormComponents';
import FormWrapper from 'shared/components/FormWrapper';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import { useUpdateVendorAccountReviewDateMutation } from 'shared/types/__generated__/graphql-type';
// #endregion
// #region Styled Components
const ReviewAccountContainer = styled(Container) `
  padding: 0;
`;
const Title = styled.div `
  font-size: 42px;
  font-family: "Gotham SSm A", "Gotham SSm B";font-style: normal;font-weight: 300;
  text-align: center;
  padding: 20px 40px .5em 40px;
  border-bottom: 2px solid #ffffff;
  color: #ed1d30;
`;
const AttentionNeededNote = styled.div `
  padding: 1em 2em 1em 2em;
  margin: 2em 0 1em 0;
  border: 2px solid #5b656e;
  font-size: 16px;
  font-family: "Gotham SSm A", "Gotham SSm B";font-style: normal;font-weight: 300;
  text-align: left;
`;
const NoteBorder = styled.div `
  border: 2px solid #dce2f3;
  background: #ffffff;
  padding-left: 40px;
  padding-right: 40px;
  padding-bottom: 3em;
`;
// #endregion
//#region Component
const ReviewAccountInfo = (props) => {
    // #region State
    const [formErrors, setFormErrors] = useState([]);
    // #endregion
    // #region Refs
    // #endregion
    //#region Hooks
    const history = useHistory();
    const location = useLocation();
    const [updateVendorAccountReviewDateMutation, { loading, error }] = useUpdateVendorAccountReviewDateMutation({
        client: props.vendorClient,
        variables: {
            vendorId: props.vendorId
        },
    });
    //#endregion
    // #region Effects
    // #endregion
    // #region Event handlers
    /**
     * Handle the skip button click event
     * This function updates the review date and redirects to the return URL if provided
     * Otherwise, it redirects to the home page
     * @param {React.MouseEvent} e - The click event
     */
    const handleSkipClicked = (e) => {
        // Redirect to the return URL
        let params = queryString.parse(location.search);
        let returnUrl = params.returnUrl ? params.returnUrl : '/';
        history.replace(returnUrl);
    };
    /**
     * Handle the continue button click event
     * This function updates the review date and redirects to the your account page
     * @param {React.MouseEvent} e - The click event
     */
    const handleContinueClicked = (e) => {
        // Call the mutation to update the review date
        updateVendorAccountReviewDateMutation();
        // Redirect to the your account page
        history.replace("/yourAccount#serviceContacts");
    };
    // #endregion
    //#region International messages
    const messages = defineMessages({
        review_account__title: {
            id: 'review_account_title',
            description: 'Title for the Review Account Info screen',
            defaultMessage: 'Review Your Shop Contacts',
        },
        review_account__body: {
            id: 'review_account_body',
            description: 'Body for the Review Account Info screen',
            defaultMessage: 'Please verify your repair contact information in our system. Maintaining accurate records allows us to provide timely approvals, service updates, and important communications regarding your account.',
        },
        review_account__skip_button: {
            id: 'review_account_skip_button',
            description: 'Skip button for the Review Account Info screen',
            defaultMessage: 'Remind me next time',
        },
        review_account__continue_button: {
            id: 'review_account_continue_button',
            description: 'Continue button for the Review Account Info screen',
            defaultMessage: 'Review shop contacts',
        },
    });
    //#endregion
    //#region Render helpers
    //#endregion
    //#region Render
    return (React.createElement(ReviewAccountContainer, null,
        React.createElement(FormWrapper, { id: "reviewAccountErrorMessages", key: "reviewAccountErrorMessages", formErrors: formErrors }),
        React.createElement(Row, { id: 'reviewAccountTitle', md: 12 },
            React.createElement(Title, { id: "reviewAccountTitleText" },
                React.createElement(FormattedMessage, Object.assign({}, messages.review_account__title)))),
        React.createElement(NoteBorder, null,
            React.createElement(AttentionNeededNote, null,
                React.createElement(FormattedMessage, Object.assign({}, messages.review_account__body))),
            React.createElement(Row, { id: 'reviewAccountActions' },
                React.createElement(Col, { md: 6, style: { justifyItems: "start" } },
                    React.createElement(ButtonStyled, { role: "button", onClick: (event) => handleSkipClicked(event), id: "reviewAccountSkipButton", style: { padding: "1rem 0 0 0", width: "fit-content" } },
                        React.createElement("img", { src: "/assets/VMS_28button_delete_blue.png", alt: "Skip" }),
                        " ",
                        React.createElement(FormattedMessage, Object.assign({}, messages.review_account__skip_button)))),
                React.createElement(Col, { md: 6, style: { justifyItems: "end" } },
                    React.createElement(ButtonStyled, { role: "button", onClick: (event) => handleContinueClicked(event), id: "reviewAccountContinueButton", style: { padding: "1rem 0 0 0", width: "fit-content" } },
                        React.createElement(FormattedMessage, Object.assign({}, messages.review_account__continue_button)),
                        " ",
                        React.createElement("img", { src: "/assets/VMS_33button_go_bblue.png", alt: "Continue" })))))));
    //#endregion
};
// #endregion
export default ReviewAccountInfo;
